/* globals moment axios route */

import ErrorHandler from '../core/ErrorHandler';

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      status: null,
    };
  },

  computed: {
    createdAt() {
      return moment(this.notification.created_at).fromNow();
    },

    isRead() {
      return !!this.notification.read_at;
    },
  },

  methods: {
    markAsRead() {
      this.status = 'loading';
      return new Promise((resolve, reject) => {
        if (this.isRead) {
          resolve();
          return;
        }
        axios
          .delete(route('api.notifications.destroy', this.notification.id))
          .then(() => {
            const notification = { ...this.notification };
            notification.read_at = moment().format();
            Event.fire('notificationUpdated', notification);
            this.onSuccess();
            resolve();
          })
          .catch((error) => {
            this.onFail(error);
            reject();
          });
      });
    },

    onSuccess() {
      this.status = null;
    },

    onFail(error) {
      this.status = 'failed';
      new ErrorHandler(error).dispatch();
      setTimeout(() => {
        this.status = null;
      }, 1500);
    },
  },
};
